$(function () {
  var header = $("header");
  var scrollTop = $(window).on("scroll", function () {
    // Fix fixed position
    var scrollTop = $("html, body").scrollTop();

    if (window.innerWidth < 1200) {
      header.css("position", "absolute").css("top", scrollTop + "px");
    } else {
      header.removeAttr("style");
    }
  });

  // $(".menu-item").on("click", function() {
  //   $(this).addClass("active");
  //   $(this)
  //     .siblings()
  //     .removeClass("active");
  // });

  if ($(".section-services").length) {
    $(window).on("scroll", sectionServicesAnim);
  }

  function sectionServicesAnim() {
    if ($(".section-services").offset().top < $(window).scrollTop() + window.innerHeight - 200) {
      $(".service .bar .value").each(function (i, elem) {
        var value = $(elem).attr("data-width");
        var duration = $(elem).attr("data-duration") + "ms" || "300ms";
        $(elem)
          .css("transition", "width " + duration)
          .css("width", value);
      });
      $(window).unbind("scroll", sectionServicesAnim);
    }
  }

  $(function () {
    $(".switchable .nav .tab").click(function () {
      var index = $(this).index();
      $(this).siblings().removeClass("active");
      $(this).addClass("active");

      $(this).parent(".nav").next().find(".page").eq(index).addClass("active").siblings().removeClass("active");

      loadPromoAnimation();
    });

    $(".switchable .nav.promo .tab").click(function () {
      var index = $(this).index();
      var dataType = $(this).data("type");

      $(this).siblings().removeClass("active");
      $(this).addClass("active");

      if (dataType === -1) {
        $(".item").slideDown();
      } else {
        $('.item[data-type="' + dataType + '"]').slideDown();
        $('.item:not([data-type="' + dataType + '"])').slideUp();
      }

      loadPromoAnimation();
    });
  });

  $(".item-head").click(function () {
    $(this).next().stop().slideToggle(200);
  });

  loadPromoAnimation();

  var gameIdList = [
    "CQSSC",
    "SSCJSC",
    "TJSSC",
    "XJSSC",
    "11x5jsc",
    "AULUCKY10",
    "AULUCKY20",
    "AULUCKY5",
    "AULUCKY8",
    "KL8JSC",
    "BJPK10",
    "BJPK10BJL",
    "F3D",
    "GD11X5",
    "GXK3",
    "GXKLSF",
    "HK6",
    "HK6JSC",
    "K3JSC",
    "KL8JSC",
    "KLSFJSC",
    "JLK3",
    "LUCKYSB",
    "PCEGG",
    "PK10JSC",
    "PL3",
    "TXFFC",
    "XYNC",
    "PK10JSCNN_A",
    "PK10JSCNN",
    "GDKLSF",
  ];

  if (window.promo) {
    renderPromo(window.promo);
  } else {
    Object.defineProperty(window, "promo", {
      set: function (data) {
        renderPromo(data);
      },
    });
  }

  function registerPromo(promoId) {
    api.registerPromo(promoId);
  }

  function renderPromo(promoData) {
    if (Array.isArray(promoData)) {
      var promoWrapper = $(`<div class="promo-wrapper"></div>`);
      promoData.forEach(function (value, index) {
        var promoItem = $(`<div class="item" data-type="${value.type}"></div>`);

        var promoId = value.promoId;
        var requestToJoin = value.requestToJoin;
        var firstDepositPromoJoinMsg = value.firstDepositPromoJoinMsg;

        if (value.imagePath) {
          promoItem.append(
            $(`
            <img class="item-head image" src="${value.imagePath}" alt="${value.title}"/>
            <div class="item-content"><h3>${value.title}</h3>
            ${value.content}
            ${
              requestToJoin
                ? `
                <div
                  class="promo--modal--footer"
                  style="display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; height: 50px;"
                >
                  ${
                    firstDepositPromoJoinMsg
                      ? `
                        <div class="promo--modal--footer--info" style="color: #999;">
                          ${firstDepositPromoJoinMsg}
                        </div>
                      `
                      : `
                        <button
                          class="promo--modal--footer--register-promo"
                          data-id="${promoId}"
                          style="cursor:pointer;padding: 10px 20px;outline:0;border:0;background-image:linear-gradient(to right, #47458A,#3185B8); color: #fff;border-radius: 4px;"
                        >
                          申请参与
                        </button>
                        `
                  }
                    </div>
                  `
                : ``
            }
            </div>`)
          );
        } else {
          promoItem.append(
            $(`<h3 class="item-head">
                  <div class="text flex">
                    <h1>${value.title}</h1>
                    <div class="left-pattern"></div>
                    <div class="right-pattern"></div>
                  </div>
                </h3>
                <div class="item-content">${value.content}</div>
               `)
          );
        }
        promoWrapper.append(promoItem);
      });

      $(function () {
        $(".promo--modal--footer--register-promo").on("click", function (e) {
          e.preventDefault();
          var promoId = $(this).data("id");
          registerPromo(promoId);
        });
      });

      $(".section-sub-page.promo .pages.promo .page").html(promoWrapper);
      loadPromoAnimation();
    }
  }

  function randomGames() {
    gameIdList.sort((a, b) => {
      return Math.random() < 0.5 ? 1 : -1;
    });
    $(".section-games .game").each(function (i, elem) {
      elem.className = `game game-${gameIdList[i]}`;
    });
  }

  if ($(".section-games .game").length !== 0) {
    $(".section-games").addClass("ready");
    setInterval(function () {
      $(".section-games").removeClass("ready");
      setTimeout(randomGames, 500);
      setTimeout(function () {
        $(".section-games").addClass("ready");
      }, 1000);
    }, 5000);
  }

  function loadPromoAnimation() {
    if ($(".section-sub-page.promo").length !== 0) {
      $(".section-sub-page.promo .page.active .item").each(function (k, i) {
        $(i).removeClass("ready");
        setTimeout(function () {
          $(i).addClass("ready");
        }, k * 150);
      });
    }
  }

  $(function () {
    $(document).on("click", ".item > .item-head", function () {
      $(this).next().stop().slideToggle();
    });
  });
});

// hash detection
$(function () {
  function detectHash() {
    var currentHash = location.hash.slice(1);
    $("[data-hash='" + currentHash + "']")
      .addClass("active")
      .siblings()
      .removeClass("active");
  }

  detectHash();
  $(".tab[data-hash]").click(function (event) {
    event.preventDefault();
    location.hash = $(this).attr("data-hash");
  });

  $('[href*="html#"]').click(function () {
    setTimeout(detectHash, 10);
    $(window).scrollTop(0);
  });
});

if (Pace) {
  Pace.on("done", initFlickity);
} else {
  $(window).on("load", initFlickity);
}

function initFlickity() {
  const bannerList = window.banner;
  const indexContainer = $("#index-banner.banner-carousel");
  const isLoggedIn = $(".before-login.hide").length !== 0;

  bannerList &&
    bannerList.length !== 0 &&
    bannerList.forEach(function (item) {
      const { imageUrl, redirectUrl, redirectGroup, redirectPage, bannerType } = item;

      if (imageUrl) {
        /**
         * Redirect Group Option
         * 0 - Promo
         * 1 - Join Us
         * 2 - Lottery
         * 3 - Product
         * 4 - Others inner page (Loyalty, Customer Service)
         * 5 - 自定义
         */

        const banner = $(`
            <div class="carousel-cell" data-swiper-autoplay="5000">
                <img ${redirectUrl ? `data-redirect=${redirectUrl}` : ""} class="img" src="${imageUrl}"/>
                <img src="${imageUrl}" class="img-bg" />
            </div>
          `);

        banner.click(() =>
          window.initBannerCarouselRedirection({
            redirectUrl,
            redirectGroup,
            redirectPage,
            isLoggedIn,
          })
        );

        /**
         * index append 首页type banner, promo append 优惠活动type banner
         * 轮播图类型 bannerType
         * 0 - 首页
         * 1 - 优惠活动
         * 2 - 其他
         */
        if (bannerType === 0) {
          indexContainer.append(banner);
        }
      }
    });

  if (bannerList && bannerList.length) {
    new Flickity(".banner-carousel", {
      wrapAround: true,
      autoPlay: 5000,
      adaptiveHeight: true,
      setGallerySize: true,
    });

    // if ($(".section-banner .banner-carousel").length !== 0) {
    //   $(".banner-carousel .carousel-cell").each(function () {
    //     var img = $(this)
    //         .find("img")
    //         .clone()
    //         .addClass("img-bg");
    //     $(this).append(img);
    //   });
    // }
  }
}
// $(function() {
//   $(window).on("load", function() {
//     window.dispatchEvent(new Event("resize"));
//   });
// });
